// extracted by mini-css-extract-plugin
module.exports = {"customers_dashboard":"Customers_customers_dashboard__3NRl_","button":"Customers_button__2YqRY"};